import { css } from '@emotion/core';
import styled from '@emotion/styled';

export const AreaSelectionWrapper = styled.div`
  display: flex;
  column-gap: ${({ charts }) => (charts ? 15 : 10)}px;
  flex-wrap: wrap;
  row-gap: 10px;
  margin-bottom: 5px;
  margin-right: -10px;
`;

export const DashletArea = styled.button`
  width: ${({ mobile, charts }) =>
    mobile ? `calc(100% / 3 - 10px)` : charts ? '140px' : '100px'};
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 7px;
  border: 1px solid var(--color-border-dark);
  border-radius: 4px;
  color: var(--color-font-placeholder);
  cursor: pointer;
  background: var(--color-background-white);
  outline: none;

  &:hover {
    border-color: var(--color-button-secondary-hover);
  }

  &:focus {
    outline: none;
  }

  i {
    width: 25px;
    height: 25px;
  }

  i:hover {
    color: var(--color-font-placeholder);
  }

  && svg {
    width: 25px;
    height: 25px;
  }

  ${({ selected }) =>
    selected
      ? css`
          border-color: var(--color-viz-cat-2-primary);
          color: var(--color-viz-cat-2-primary);

          i,
          i:hover {
            color: var(--color-viz-cat-2-primary);
          }
        `
      : css`
          &:disabled {
            border-color: var(--color-border-dark);
            color: var(--color-font-placeholder);
          }

          &:disabled i {
            color: var(--color-font-placeholder);
          }
        `}
`;

export const DashletAreaText = styled.p`
  font-size: 1.4rem;
  margin-top: 20px;
  && {
    margin-bottom: -5px;
  }
`;
